export default __webpack_public_path__ + "static/media/Tiger's Helm of the Primeval.7eecee7d.jpg";